<template>
  <div class="main">
    <div id="container" ref="con"></div>
  </div>
</template>

<script type='module'>
import THREE from  './../js/three.min.js'
import TWEEN from './../js/tween.min.js'
import './../js/CSS3DRenderer.js'
// import './../js/three.module.js';
import { OrbitControls } from './../js/OrbitControls.js';
var uv =function () {
    var s = []
    for (var i = 0;i<75;i++){
        s.push(Math.floor(Math.random()*9900+100))
    }
    return s
}
var uvNum = uv()
var pv = function () {
    var s = []
    for (var i = 0;i<75;i++){
        s.push(Math.floor(Math.random()*10000+uvNum[i]))
    }
    return s
}
var pvNum = pv()
var table = [
        "WEB页面", "上海报业", "pv"+ ' '+pvNum[0]+','+'uv'+' '+uvNum[0], 1, 1,
        "WEB页面", "亚洲宠物展", "pv"+ ' '+pvNum[1]+','+'uv'+' '+uvNum[1], 18, 1,
        "WEB页面", "帐米后台管理系统", "pv"+ ' '+pvNum[2]+','+'uv'+' '+uvNum[2], 1, 2,
        "微信公众号", "苏芮铝型材", "pv"+ ' '+pvNum[3]+','+'uv'+' '+uvNum[3], 13, 3,
        "WEB页面", "TCE服装展", "pv"+ ' '+pvNum[4]+','+'uv'+' '+uvNum[4], 13, 2,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[5]+','+'uv'+' '+uvNum[5], 1, 4,
        "WEB页面", "Ultrain超脑链", "pv"+ ' '+pvNum[6]+','+'uv'+' '+uvNum[6], 15, 2,
        "WEB页面", "创联赛", "pv"+ ' '+pvNum[7]+','+'uv'+' '+uvNum[7], 16, 2,
        "微信公众号", "苏芮铝型材", "pv"+ ' '+pvNum[8]+','+'uv'+' '+uvNum[8], 13, 3,
        "WEB页面", "自动化广告跟踪", "pv"+ ' '+pvNum[9]+','+'uv'+' '+uvNum[9], 18, 2,
        "WEB页面", "逆行投放效果监控", "pv"+ ' '+pvNum[10]+','+'uv'+' '+uvNum[10], 1, 3,
        "WEB页面", "嘉跃喷泉新官网", "pv"+ ' '+pvNum[11]+','+'uv'+' '+uvNum[11], 2, 3,
        "微信公众号", "苏芮铝型材", "pv"+ ' '+pvNum[12]+','+'uv'+' '+uvNum[12], 13, 3,
        "微信公众号", "职播百胜", "pv"+ ' '+pvNum[13]+','+'uv'+' '+uvNum[13], 14, 3,
        "APP", "乐动APP", "pv"+ ' '+pvNum[14]+','+'uv'+' '+uvNum[14], 2, 4,
        "微信公众号", "H5画板", "pv"+ ' '+pvNum[15]+','+'uv'+' '+uvNum[15], 16, 3,
        "微信公众号", "易点抓娃娃", "pv"+ ' '+pvNum[16]+','+'uv'+' '+uvNum[16], 17, 3,
        "APP", "乐动APP", "pv"+ ' '+pvNum[17]+','+'uv'+' '+uvNum[17], 18, 3,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[18]+','+'uv'+' '+uvNum[18], 1, 4,
        "APP", "乐动APP", "pv"+ ' '+pvNum[19]+','+'uv'+' '+uvNum[19], 2, 4,
        "微信公众号", "H5画板", "pv"+ ' '+pvNum[20]+','+'uv'+' '+uvNum[20], 3, 4,
        "WEB页面", "逆行投放效果监控", "pv"+ ' '+pvNum[21]+','+'uv'+' '+uvNum[21], 4, 4,
        "WEB页面", "上海报业", "pv"+ ' '+pvNum[22]+','+'uv'+' '+uvNum[22], 5, 4,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[23]+','+'uv'+' '+uvNum[23], 6, 4,
        "WEB页面", "逆行投放效果监控", "pv"+ ' '+pvNum[24]+','+'uv'+' '+uvNum[24], 7, 4,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[25]+','+'uv'+' '+uvNum[25], 8, 4,
        "APP", "乐动APP", "pv"+ ' '+pvNum[26]+','+'uv'+' '+uvNum[26], 9, 4,
        "WEB页面", "逆行投放效果监控", "pv"+ ' '+pvNum[27]+','+'uv'+' '+uvNum[27], 10, 4,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[28]+','+'uv'+' '+uvNum[28], 11, 4,
        "WEB页面", "上海报业", "pv"+ ' '+pvNum[29]+','+'uv'+' '+uvNum[29], 12, 4,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[30]+','+'uv'+' '+uvNum[30], 13, 4,
        "WEB页面", "逆行投放效果监控", "pv"+ ' '+pvNum[31]+','+'uv'+' '+uvNum[31], 14, 4,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[32]+','+'uv'+' '+uvNum[32], 15, 4,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[33]+','+'uv'+' '+uvNum[33], 16, 4,
        "WEB页面", "逆行投放效果监控", "pv"+ ' '+pvNum[34]+','+'uv'+' '+uvNum[34], 17, 4,
        "APP", "乐动APP", "pv"+ ' '+pvNum[35]+','+'uv'+' '+uvNum[35], 18, 4,
        "WEB页面", "逆行投放效果监控", "pv"+ ' '+pvNum[36]+','+'uv'+' '+uvNum[36], 1, 5,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[37]+','+'uv'+' '+uvNum[37], 2, 5,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[38]+','+'uv'+' '+uvNum[38], 3, 5,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[39]+','+'uv'+' '+uvNum[39], 4, 5,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[40]+','+'uv'+' '+uvNum[40], 5, 5,
        "APP", "乐动APP", "pv"+ ' '+pvNum[41]+','+'uv'+' '+uvNum[41], 6, 5,
        "WEB页面", "逆行投放效果监控", "pv"+ ' '+pvNum[42]+','+'uv'+' '+uvNum[42], 7, 5,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[43]+','+'uv'+' '+uvNum[43], 8, 5,
        "WEB页面", "逆行投放效果监控", "pv"+ ' '+pvNum[44]+','+'uv'+' '+uvNum[44], 9, 5,
        "WEB页面", "上海报业", "pv"+ ' '+pvNum[45]+','+'uv'+' '+uvNum[45], 10, 5,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[46]+','+'uv'+' '+uvNum[46], 11, 5,
        "WEB页面", "逆行投放效果监控", "pv"+ ' '+pvNum[47]+','+'uv'+' '+uvNum[47], 12, 5,
        "APP", "乐动APP", "pv"+ ' '+pvNum[48]+','+'uv'+' '+uvNum[48], 13, 5,
        "WEB页面", "上海报业", "pv"+ ' '+pvNum[49]+','+'uv'+' '+uvNum[49], 14, 5,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[50]+','+'uv'+' '+uvNum[50], 15, 5,
        "WEB页面", "TCE服装展", "pv"+ ' '+pvNum[51]+','+'uv'+' '+uvNum[51], 16, 5,
        "WEB页面", "TCE服装展", "pv"+ ' '+pvNum[52]+','+'uv'+' '+uvNum[52], 17, 5,
        "WEB页面", "上海报业", "pv"+ ' '+pvNum[53]+','+'uv'+' '+uvNum[53], 18, 5,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[54]+','+'uv'+' '+uvNum[54], 8, 5,
        "WEB页面", "逆行投放效果监控", "pv"+ ' '+pvNum[55]+','+'uv'+' '+uvNum[55], 9, 5,
        "WEB页面", "上海报业", "pv"+ ' '+pvNum[56]+','+'uv'+' '+uvNum[56], 10, 5,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[57]+','+'uv'+' '+uvNum[57], 11, 5,
        "WEB页面", "逆行投放效果监控", "pv"+ ' '+pvNum[58]+','+'uv'+' '+uvNum[58], 12, 5,
        "APP", "乐动APP", "pv"+ ' '+pvNum[59]+','+'uv'+' '+uvNum[59], 13, 5,
        "WEB页面", "上海报业", "pv"+ ' '+pvNum[60]+','+'uv'+' '+uvNum[60], 14, 5,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[61]+','+'uv'+' '+uvNum[61], 15, 5,
        "WEB页面", "TCE服装展", "pv"+ ' '+pvNum[62]+','+'uv'+' '+uvNum[62], 16, 5,
        "WEB页面", "TCE服装展", "pv"+ ' '+pvNum[63]+','+'uv'+' '+uvNum[63], 17, 5,
        "WEB页面", "上海报业", "pv"+ ' '+pvNum[64]+','+'uv'+' '+uvNum[64], 18, 5,
        "WEB页面", "逆行投放效果监控", "pv"+ ' '+pvNum[65]+','+'uv'+' '+uvNum[65], 9, 5,
        "WEB页面", "上海报业", "pv"+ ' '+pvNum[66]+','+'uv'+' '+uvNum[66], 10, 5,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[67]+','+'uv'+' '+uvNum[67], 11, 5,
        "WEB页面", "逆行投放效果监控", "pv"+ ' '+pvNum[68]+','+'uv'+' '+uvNum[68], 12, 5,
        "APP", "乐动APP", "pv"+ ' '+pvNum[69]+','+'uv'+' '+uvNum[69], 13, 5,
        "WEB页面", "上海报业", "pv"+ ' '+pvNum[70]+','+'uv'+' '+uvNum[70], 14, 5,
        "微信小程序", "时光美迹", "pv"+ ' '+pvNum[71]+','+'uv'+' '+uvNum[71], 15, 5,
        "WEB页面", "TCE服装展", "pv"+ ' '+pvNum[72]+','+'uv'+' '+uvNum[72], 16, 5,
        "WEB页面", "TCE服装展", "pv"+ ' '+pvNum[73]+','+'uv'+' '+uvNum[73], 17, 5,
        "WEB页面", "上海报业", "pv"+ ' '+pvNum[74]+','+'uv'+' '+uvNum[74], 18, 5
    ];
var camera, scene, renderer;
var controls;
var objects = [];
var targets = { table: [], sphere: [], helix: [], grid: [] };
var j;
export default {
    data(){
        return{

        }
    },
    mounted(){
        // var me = this
        // this.$nextTick(()=>{
        //     me.all()
        // })
    },
    methods:{
        clearAll(){
            this.$refs.con.innerHTML = '';
            camera = null
            scene = null
            renderer = null
            controls = null
            objects = [];
            targets = { table: [], sphere: [], helix: [], grid: [] };
            j = clearInterval(this.autoRo.clickTo)
        },
        init(){
            this.$refs.con.innerHTML = '';
            var me =this
            camera = new THREE.PerspectiveCamera( 40, window.innerWidth / window.innerHeight, 1, 10000 );
            camera.position.z = 1500;
            scene = new THREE.Scene();
            // table
            for ( var i = 0; i < table.length; i += 5 ) {
                var element = document.createElement( 'div' );
                element.className = 'element';
                element.style.backgroundColor = 'rgba(0,127,127,' + ( Math.random() * 0.5 + 0.25 ) + ')';
                var number = document.createElement( 'div' );
                number.className = 'number';
                number.textContent = (i/5) + 1;
                element.appendChild( number );
                var symbol = document.createElement( 'div' );
                symbol.className = 'symbol';
                symbol.textContent = table[ i ];
                element.appendChild( symbol );
                var details = document.createElement( 'div' );
                details.className = 'details';
                details.innerHTML = table[ i + 1 ] + '<br>' + table[ i + 2 ];
                element.appendChild( details );
                var object = new THREE.CSS3DObject( element );
                object.position.x = Math.random() * 4000 - 2000;
                object.position.y = Math.random() * 4000 - 2000;
                object.position.z = Math.random() * 4000 - 2000;
                object.rotation.x=45*Math.PI/180;
                object.rotation.y=45*Math.PI/180;
                object.rotation.z=45*Math.PI/180;
                scene.add( object );
                objects.push( object );
                //
                var object = new THREE.Object3D();
                object.position.x = ( table[ i + 3 ] * 140 ) - 1330;
                object.position.y = - ( table[ i + 4 ] * 180 ) + 990;

                targets.table.push( object );

            }

            // sphere

            var vector = new THREE.Vector3();

            for ( var i = 0, l = objects.length; i < l; i ++ ) {

                var phi = Math.acos( -1 + ( 2 * i ) / l );
                var theta = Math.sqrt( l * Math.PI ) * phi;

                var object = new THREE.Object3D();

                object.position.x = 500 * Math.cos( theta ) * Math.sin( phi );
                object.position.y = 500 * Math.sin( theta ) * Math.sin( phi );
                object.position.z = 500 * Math.cos( phi );

                vector.copy( object.position ).multiplyScalar( 2 );

                object.lookAt( vector );

                targets.sphere.push( object );

            }

            // helix

            var vector = new THREE.Vector3();

            for ( var i = 0, l = objects.length; i < l; i ++ ) {

                var phi = i * 0.175 + Math.PI;

                var object = new THREE.Object3D();

                object.position.x = 900 * Math.sin( phi );
                object.position.y = - ( i * 8 ) + 250;
                object.position.z = 900 * Math.cos( phi );

                vector.x = object.position.x * 2;
                vector.y = object.position.y;
                vector.z = object.position.z * 2;

                object.lookAt( vector );

                targets.helix.push( object );

            }

            // grid

            for ( var i = 0; i < objects.length; i ++ ) {

                var object = new THREE.Object3D();

                object.position.x = ( ( i % 5 ) * 300 ) - 450;
                object.position.y = ( - ( Math.floor( i / 5 ) % 5 ) * 200 ) + 450;
                object.position.z = ( Math.floor( i / 25 ) ) * 100 ;

                targets.grid.push( object );

            }

            //

            renderer = new THREE.CSS3DRenderer();
            renderer.setSize( window.innerWidth, window.innerHeight );
            renderer.domElement.style.position = 'absolute';
            document.getElementById( 'container' ).appendChild( renderer.domElement );

            //

            controls = new OrbitControls( camera, renderer.domElement );
            controls.rotateSpeed = 0;
            controls.minDistance = 500;
            controls.maxDistance = 6000;
            controls.autoRotate = true;
            controls.autoRotateSpeed = 2
            // controls.rotateSpeed = 10;
            controls.addEventListener( 'change', this.render );

            me.transform( targets.sphere, 2000 );

            //

            window.addEventListener( 'resize', this.onWindowResize, false );
        },
        transform(targets, duration){
            TWEEN.removeAll();
            for ( var i = 0; i < objects.length; i ++ ) {
                var object = objects[ i ];
                var target = targets[ i ];
                new TWEEN.Tween( object.position )
                        .to( { x: target.position.x, y: target.position.y, z: target.position.z }, Math.random() * duration + duration )
                        .easing( TWEEN.Easing.Exponential.InOut )
                        .start();
                new TWEEN.Tween( object.rotation )
                        .to( { x: target.rotation.x, y: target.rotation.y, z: target.rotation.z }, Math.random() * duration + duration )
                        .easing( TWEEN.Easing.Exponential.InOut )
                        .start();
            }
            new TWEEN.Tween( this )
                    .to( {}, duration * 2 )
                    .onUpdate( this.render )
                    .start();
        },
        onWindowResize(){
            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();
            renderer.setSize( window.innerWidth, window.innerHeight );
            this.render();
        },
        animate(){
            if(controls==undefined)
            {
                return
            }
            TWEEN.update();
            controls.update();
            requestAnimationFrame( this.animate );
        },
        render(){
            renderer.render( scene, camera );
        },
        autoRo () {
            var T = 20000
            var me = this
            j = setInterval(clickTo, T);
            function clickTo(){
                clearInterval(j)
                me.transform( targets.helix, 2000 );
                j=setInterval(clickTo2, T);
            }
            function clickTo2(){
                clearInterval(j)
                me.transform( targets.grid, 2000 );
                j=setInterval(clickTo3, T);
            }
            function clickTo3(){
                clearInterval(j)
                me.transform( targets.sphere, 2000 );
                j=setInterval(clickTo, T);
            }
        },
        all(){
            // debugger;
            this.init()
            this.animate()
            this.autoRo()
        },
        
    }
}

</script>

<style lang="less">
.main{
    a {
        color: #ffffff;
    }

    #info {
        position: absolute;
        width: 100%;
        color: #ffffff;
        padding: 5px;
        font-family: Monospace;
        font-size: 13px;
        font-weight: bold;
        text-align: center;
        z-index: 1;
    }

    #menu {
        position: absolute;
        bottom: 20px;
        width: 100%;
        text-align: center;
        opacity: 0;
    }

    .element {
        width: 140px;
        height: 160px;
        box-shadow: 0px 0px 12px rgba(0,255,255,0.5);
        border: 1px solid rgba(127,255,255,0.25);
        text-align: center;
        cursor: default;
        
        /* border:1px solid red; */
    }

    .element:hover {
        box-shadow: 0px 0px 12px rgba(0,255,255,0.75);
        border: 1px solid rgba(127,255,255,0.75);
    }

    .element .number {
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 12px;
        color: rgba(127,255,255,0.75);
    }

    .element .symbol {
        position: absolute;
        top: 40px;
        left: 0px;
        right: 0px;
        font-size: 24px;
        font-weight: bold;
        color: rgba(255,255,255,0.75);
        text-shadow: 0 0 10px rgba(0,255,255,0.95);
    }

    .element .details {
        position: absolute;
        bottom: 15px;
        left: 0px;
        right: 0px;
        font-size: 12px;
        color: rgba(127,255,255,0.75);
    }

    button {
        color: rgba(127,255,255,0.75);
        background: transparent;
        outline: 1px solid rgba(127,255,255,0.75);
        border: 0px;
        padding: 5px 10px;
        cursor: pointer;
    }
    button:hover {
        background-color: rgba(0,255,255,0.5);
    }
    button:active {
        color: #000000;
        background-color: rgba(0,255,255,0.75);
    }
}

</style>




// WEBPACK FOOTER //
// src/components/bg.vue